import { RefObject } from 'react';
import { Box } from '@mui/material';
import { Turnstile, TurnstileProps } from '@marsidev/react-turnstile';
import { Control, FieldValues, Path, useController } from 'react-hook-form';

type Props<TFieldValues extends FieldValues = FieldValues> = Omit<
  TurnstileProps,
  'siteKey' | 'ref'
> & {
  control: Control<TFieldValues>;
  name: Path<TFieldValues>;
  turnstileRef: RefObject<any>;
};

export const TurnstileWidget = <TFieldValues extends FieldValues>({
  name,
  control,
  turnstileRef,
}: Props<TFieldValues>): JSX.Element => {
  const publicKey = process.env.REACT_APP_TURNSTILE_PUBLIC_KEY || '';
  const hasCaptcha = process.env.REACT_APP_TURNSTILE_ENABLED || 'false';

  const { field, fieldState } = useController<TFieldValues>({
    name,
    control,
  });

  const { onChange } = field;

  const handleTokenChange = (token?: string) => {
    onChange(token);
  };

  const handleErrorOrExpire = () => {
    handleTokenChange(undefined);

    if (turnstileRef.current) {
      turnstileRef.current.reset();
    }
  };

  const renderCaptcha = () => {
    if (hasCaptcha === 'true') {
      return (
        <div style={{ marginBottom: '1rem' }}>
          <Turnstile
            ref={turnstileRef}
            siteKey={publicKey}
            onSuccess={handleTokenChange} // atualiza o token quando o desafio é resolvido com sucesso
            onError={handleErrorOrExpire} // reset caso de erro
            onExpire={() => turnstileRef.current?.reset()}
          />
          {fieldState.error && (
            <p style={{ color: 'red', marginTop: '8px' }}>
              {fieldState.error.message}
            </p>
          )}
        </div>
      );
    }

    return null;
  };

  return <Box>{renderCaptcha()}</Box>;
};
